import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Home, PencilLine, Camera, BarChart3, User, LogOut, Sun, Moon } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { useTheme } from '@/lib/theme';
import { cn } from '@/lib/cn';

const TABS = [
  { to: '/app', label: 'Inicio', icon: Home, end: true },
  { to: '/app/registrar', label: 'Registrar', icon: PencilLine },
  { to: '/app/fotos', label: 'Fotos', icon: Camera },
  { to: '/app/progreso', label: 'Progreso', icon: BarChart3 },
  { to: '/app/perfil', label: 'Perfil', icon: User },
];

export function ClientLayout() {
  const { logout } = useAuth();
  const { theme, toggle } = useTheme();
  const nav = useNavigate();

  async function handleLogout() {
    await logout();
    nav('/login', { replace: true });
  }

  return (
    <div className="min-h-full flex flex-col pb-24">
      <header className="flex items-center justify-between px-4 h-14 border-b border-border bg-card sticky top-0 z-20">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-accent flex items-center justify-center font-extrabold text-white text-sm">
            D
          </div>
          <span className="font-extrabold">diegoNutri</span>
        </div>
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={toggle}
            aria-label="Cambiar tema"
            className="p-2 rounded text-text-dim hover:bg-bg"
          >
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <button
            type="button"
            onClick={handleLogout}
            aria-label="Cerrar sesión"
            className="p-2 rounded text-text-dim hover:bg-danger-dim hover:text-danger"
          >
            <LogOut size={18} />
          </button>
        </div>
      </header>

      <main className="flex-1 p-4 max-w-3xl w-full mx-auto">
        <Outlet />
      </main>

      <nav className="fixed bottom-0 inset-x-0 bg-card border-t border-border flex justify-around py-2 z-30">
        {TABS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-0.5 px-1.5 py-1 text-[10px] font-semibold flex-1',
                isActive ? 'text-accent' : 'text-text-dim',
              )
            }
          >
            <item.icon size={18} />
            <span className="truncate max-w-full">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
